<!-- Modal Header -->
<div class="modal-header">
  <div>
    <h4 class="modal-title mb-0 fw-bold">{{ getTitle() }}</h4>
    <small class="text-secondary">Gestionar personas relacionadas al contrato</small>
  </div>
  <button type="button" 
          class="btn-close" 
          (click)="dismiss()" 
          aria-label="Close">
    <i class="fas fa-times"></i>
  </button>
</div>

<!-- Modal Body -->
<div class="modal-body p-3">
  <!-- Search and Add Section -->
  <div class="search-section mb-4">
    <div class="card border shadow-sm">
      <div class="card-header">
        <h6 class="mb-0 text-dark">
          <i class="fas fa-search me-2"></i>
          Buscar y Agregar Personas
        </h6>
      </div>
      <div class="card-body">
        <!-- Botones de acción directos -->
        <div class="d-flex gap-2 mb-3">
          <button type="button" 
                  class="btn btn-outline-primary" 
                  (click)="openSearchModal()"
                  title="Buscar personas existentes">
            <i class="fas fa-search me-1"></i>
            Buscar
          </button>
          <button type="button" 
                  class="btn btn-primary" 
                  (click)="openCreateModal()"
                  title="Crear nueva persona">
            <i class="fas fa-plus me-1"></i>
            Crear {{ getPersonTypeLabel() }}
          </button>
        </div>
        
      </div>
    </div>
  </div>

  <!-- Selected Persons Section -->
  <div class="selected-section">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h6 class="text-dark mb-0">
        <i class="fas fa-users me-2"></i>
        Personas Seleccionadas
        <span class="badge bg-secondary ms-2">{{ selectedPersons.length }}</span>
      </h6>
      
      <div class="action-buttons">
        <button type="button" 
                class="btn btn-outline-danger btn-sm me-2" 
                (click)="clearAllSelections()"
                [disabled]="selectedPersons.length === 0"
                title="Limpiar todas las selecciones">
          <i class="fas fa-trash me-1"></i>
          Limpiar Todo
        </button>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="selectedPersons.length === 0" class="empty-state text-center py-5">
      <div class="empty-icon mb-3">
        <i class="fas fa-user-friends fa-3x text-muted"></i>
      </div>
      <h6 class="text-muted mb-2">No hay personas seleccionadas</h6>
      <p class="text-muted small mb-0">
        Utilice la sección de búsqueda para encontrar y agregar personas al contrato
      </p>
    </div>

    <!-- Selected Persons Grid -->
    <div *ngIf="selectedPersons.length > 0" class="persons-grid">
      <div *ngFor="let person of selectedPersons; let i = index; trackBy: trackByPersonId" 
           class="person-card" 
           [attr.data-index]="i">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-body p-3">
            <!-- Person Avatar and Basic Info -->
            <div class="d-flex align-items-start">
              <div class="avatar-container me-3">
                <div class="avatar bg-gradient-primary text-white">
                  {{ getPersonInitials(person) }}
                </div>
              </div>
              
              <div class="person-info flex-grow-1">
                <h6 class="person-name mb-1">{{ getPersonName(person) }}</h6>
                <div class="person-details">
                  <div class="detail-item mb-1">
                    <i class="fas fa-id-card text-muted me-1"></i>
                    <span class="text-muted small">{{ getPersonDocument(person) }}</span>
                  </div>
                  <div class="detail-item mb-1">
                    <i class="fas fa-envelope text-muted me-1"></i>
                    <span class="text-muted small">{{ getPersonEmail(person) }}</span>
                  </div>
                  <div class="detail-item">
                    <i class="fas fa-map-marker-alt text-muted me-1"></i>
                    <span class="text-muted small">{{ getPersonAddress(person) }}</span>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
          
          <!-- Card Footer with Additional Actions -->
          <div class="card-footer bg-light border-0 py-2">
            <div class="d-flex justify-content-between align-items-center">
              <small class="text-muted">
                <i class="fas fa-user-tag me-1"></i>
                {{ getPersonTypeLabel() }}
              </small>
              <div class="d-flex align-items-center gap-2">
                <span class="badge bg-success">
                  <i class="fas fa-check me-1"></i>
                  Seleccionado
                </span>
                <!-- Remove Button -->
                <button type="button" 
                        class="btn btn-outline-danger btn-sm remove-btn" 
                        (click)="onDelete(i)"
                        title="Eliminar de la selección">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Footer -->
<div class="modal-footer border-0 bg-light">
  <div class="d-flex justify-content-between align-items-center w-100">
    <!-- Summary Info -->
    <div class="summary-info">
      <small class="text-muted">
        <i class="fas fa-info-circle me-1"></i>
        {{ selectedPersons.length }} persona(s) seleccionada(s)
      </small>
    </div>
    
    <!-- Action Buttons -->
    <div class="action-buttons">
      <button type="button" 
              class="btn btn-outline-secondary me-2" 
              (click)="dismiss()">
        <i class="fas fa-times me-1"></i>
        Cancelar
      </button>
      
      <button type="button" 
              class="btn btn-primary" 
              [disabled]="loading || selectedPersons.length === 0" 
              (click)="save()">
        <span class="spinner-border spinner-border-sm me-2" *ngIf="loading"></span>
        <i class="fas fa-save me-1" *ngIf="!loading"></i>
        {{ loading ? 'Guardando...' : 'Guardar Cambios' }}
      </button>
    </div>
  </div>
</div>

<!-- Loading Overlay -->
<div *ngIf="loading" class="loading-overlay">
  <div class="loading-content">
    <div class="spinner-border text-primary mb-3" role="status"></div>
    <p class="mb-0">Guardando cambios...</p>
  </div>
</div>

<!-- Templates para formularios -->
<ng-template #OwnerForm>
  <app-owner-form 
    [edit]="false" 
    [editData]="null" 
    [createInMemory]="true"
    [createInMemoryArray]="[]" 
    (closeAction)="onPersonCreated($event)" 
    (cancelAction)="onCreateCancel()">
  </app-owner-form>
</ng-template>

<ng-template #TenantForm>
  <app-tenant-form 
    [edit]="false" 
    [editData]="null" 
    [createInMemory]="true"
    [createInMemoryArray]="[]" 
    (closeAction)="onPersonCreated($event)" 
    (cancelAction)="onCreateCancel()">
  </app-tenant-form>
</ng-template>

<ng-template #GuarantorForm>
  <app-guarantor-form 
    [edit]="false" 
    [editData]="null" 
    [createInMemory]="true"
    [createInMemoryArray]="[]" 
    (closeAction)="onPersonCreated($event)" 
    (cancelAction)="onCreateCancel()">
  </app-guarantor-form>
</ng-template>

<ng-template #SearchModal>
  <app-entities-for-contract-search 
    [searchType]="getSearchType()" 
    (selectEntity)="onPersonSelected($event)">
  </app-entities-for-contract-search>
</ng-template>
